<template>
  <div class="user-list">
    <div class="content-header"></div>
    <div class="content-wrapper">
      <SearchRow ref="searchRow" @onFilter="onFilter" @onHandleReset="onHandleReset" />

      <div class="content-list">
        <el-table
          v-loading="listLoading"
          border
          :data="userList"
          :header-cell-style="{
            color: 'rgba(13, 13, 13, 85)',
            'text-align': 'center',
          }"
        >
          <el-table-column label="供应商名称" prop="supplierName" align="center" />
          <el-table-column label="供应商编码" prop="supplierCode" align="center" />
          <el-table-column label="所属价格区域" prop="priceRegionName" align="center" />
          <el-table-column label="账号" prop="loginAccount" align="center" />
          <el-table-column label="姓名" prop="userName" align="center" />
          <el-table-column label="电话" prop="workPhone" align="center" />
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button plain size="mini" type="primary" icon="el-icon-edit" @click="editUserMsg(scope.row)">编辑</el-button>
              <el-button plain size="mini" type="primary" @click="resetPassword(scope.row)">重置密码</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="content-pagination">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            :page-sizes="[10, 20, 30, 40]"
            :current-page="userParams.page"
            :page-size="userParams.pageSize"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </div>
    <!-- 重置密码dialog -->
    <el-dialog title="提示" :visible.sync="centerDialogVisible" width="32%" center>
      <span v-if="resetPass">确定要将账号为 {{operatingRow.loginAccount || ''}} 的密码重置为： Abishopsign@2022</span>
      <span v-else>账号 {{operatingRow.loginAccount || ''}} 密码已成功重置</span>

      <span slot="footer" class="dialog-footer" v-if="resetPass">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="resetPasswordSure" style="marginLeft">确 定</el-button>
      </span>
      <span slot="footer" class="dialog-footer" v-else>
        <el-button type="primary" @click="centerDialogVisible = false" style="marginLeft" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import SearchRow from './components/search-row'
import { localStorageUtils } from '@/utils/localstorage'

export default {
  name: 'user-list',
  components: {
    SearchRow
  },
  data () {
    return {
      userParams: {
        supplierName: '',
        supplierCode: '',
        priceRegion: '',
        loginAccount: '',
        userName: '',
        workPhone: '',
        page: 1,
        pageSize: 10
      },
      operatingRow: {
        loginAccount: '',
        userId: ''
      },
      listLoading: false,
      total: 10,
      userList: [],
      centerDialogVisible: false,
      resetPass: true
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'user-info') {
      localStorageUtils.set('bccUserQueryParams', JSON.stringify(this.userParams))
    } else {
      localStorageUtils.remove('bccUserQueryParams')
    }
    next()
  },

  watch: {
    '$route': {
      handler (to, from) {
        this.getQueryParams()
      },
      immediate: true
    }
  },
  methods: {
    getQueryParams () {
      if (localStorageUtils.get('bccUserQueryParams')) {
        this.userParams = JSON.parse(localStorageUtils.get('bccUserQueryParams'))
        this.$nextTick(() => {
          this.$refs.searchRow.setUserParams(this.userParams)
        })
      }
      this.getAllUserList()
      localStorageUtils.remove('bccUserQueryParams')
    },
    // 分页器
    handleCurrentChange (val) {
      this.userParams.page = val
      this.getAllUserList()
    },
    handleSizeChange (val) {
      this.userParams.pageSize = val
      this.getAllUserList()
    },
    editUserMsg (row) {
      localStorageUtils.set('userInfo', JSON.stringify(row))
      this.$router.push({
        path: '/bcc/user/info',
        query: {
          type: 'edit'
        }
      })
    },
    resetPassword (row) {
      this.resetPass = true
      this.operatingRow = row
      this.centerDialogVisible = true
    },
    // 确定重置密码
    async resetPasswordSure () {
      const { data } = await this.$store.dispatch('getResetPassword', { userId: this.operatingRow.userId })
      if (data.resultCode === '0') {
        this.resetPass = false
      }
      this.centerDialogVisible = false
    },
    // 获取所有人员信息列表
    async getAllUserList () {
      this.listLoading = true
      const { data } = await this.$store.dispatch('getUserAcountNumber', this.userParams)
      this.listLoading = false
      if (data.resultCode === '0') {
        const { resultData = {} } = data
        this.userList = resultData.records || []
        this.total = resultData.pageProps?.totalCounts || 0
      }
    },
    onHandleReset () {
      this.userParams = this.$options.data().userParams
      this.getAllUserList()
    },
    onFilter (val) {
      this.userParams = Object.assign(this.userParams, val)
      this.userParams.page = 1
      this.getAllUserList()
    }
  }
}
</script>

<style lang="scss" scoped>
.content-header {
  height: 100px;
  background: url('../../../assets/images/banner-menu.jpg') center no-repeat;
  background-size: cover;
}
.content-list {
  margin-top: $content-middle;
}
.content-pagination {
  text-align: center;
  margin-top: $content-large;
}

::v-deep .el-dialog__header {
  border-bottom: 0px solid #dddddd;
}
::v-deep .el-dialog__footer {
  text-align: center;
  border-top: 0px solid #dddddd;
  padding-top: 16px;
}
::v-deep .el-dialog--center .el-dialog__body {
  text-align: center;
  padding: 25px 25px 30px;
  color: rgba(16, 16, 16, 100);
  font-size: 17px;
  font-family: 'Microsoft Yahei';
}
</style>
<style lang="scss">
.user-list {
  .el-button--primary.is-plain {
    background: #ffff;
    color: #409eff;
  }
  .el-button--primary.is-plain:hover,
  .el-button--primary.is-plain:active {
    background: #409eff;
    color: #fff;
  }
}
</style>
